import { Mutation } from 'app/types/mutation'
import { gql } from 'graphql-request'

export const createCommentMutation = gql`
  mutation createComment($parent: String!, $comment: String!) {
    comment(parent: $parent, comment: $comment) {
      id
      success
      reason
    }
  }
`

export const editCommentMutation = gql`
  mutation editComment($id: String!, $comment: String!) {
    updateComment(id: $id, comment: $comment) {
      id
      success
      reason
    }
  }
`

export const deleteCommentMutation = gql`
  mutation deleteComment($id: String!) {
    deleteComment(id: $id) {
      id
      success
      reason
    }
  }
`

export const commentMutationResult = (data: any) => {
  return data.comment as Mutation
}

export const editCommentMutationResult = (data: any) => {
  return data.updateComment as Mutation
}

export const deleteCommentMutationResult = (data: any) => {
  return data.deleteComment as Mutation
}
